import React from 'react'

function SmartviewContentSeparator ({ className }) {
  const classNames = [
    'smartview-content-separator',
    'border-t',
    'border-gray-200'
  ]

  return (
    <div className={classNames.concat(className).join(' ')} />
  )
}

SmartviewContentSeparator.defaultProps = {
  className: ['my-8']
}

export default SmartviewContentSeparator
